export const TICKET_TYPE = [
  {
    value: 1,
    label: 'Type 1 - Discount only for Life members & Youth members but charge additional people and other users.',
  },
  { value: 2, label: 'Type 2- Charge everyone but discount for person qualify criteria' },
];
